export const getWeekdayFromDate = (date: string): string => {
  return Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(
    new Date(date)
  );
};
